import { Typography } from "@hellocarbo/lasagne";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router";

import SubscriptionCard from "@/components/Pricing/SubscriptionCard";

function Pricing() {
  const { t } = useTranslation("pricing");
  return (
    <div className="mx-xl my-lg bg-grayscale-xx-light min-h-screen">
      <div className="mb-md gap-sm flex items-center">
        <Link to={-1 as To}>
          <ChevronLeft className="size-md text-secondary" />
        </Link>
        <Typography step="3">{t(`pricing:choosePlan`)}</Typography>
      </div>
      <div className="gap-md grid grid-cols-1 lg:grid-cols-3">
        <SubscriptionCard subscriptionType="pro" price={1200} />
        <SubscriptionCard subscriptionType="essential" price={1440} />
        <SubscriptionCard subscriptionType="premium" price={1920} />
      </div>
    </div>
  );
}

export default Pricing;
